module.exports = __webpack_public_path__ + "img/Feature.c3f10e04.jpg";